import { render, staticRenderFns } from "./ApproveAttach.vue?vue&type=template&id=554face2&"
import script from "./ApproveAttach.vue?vue&type=script&lang=js&"
export * from "./ApproveAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports